import {
  teamRolesDataAccessManageLimitedPermission,
  teamRolesDataAccessManagePermission,
  teamRolesMaintainLimitedPermission,
  teamRolesMaintainPermission,
  teamRolesManageLimitedPermission,
  teamRolesManagePermission,
  teamRolesManageLifecycleLimitedPermission,
  teamRolesManageLifecyclePermission,
} from '@agilelab/plugin-wb-rbac-common';
import { PracticeShaperRelationEnum, TeamRole, TeamRoleEnum } from './types';

export const ownerTeamRole: TeamRole = {
  name: TeamRoleEnum.OWNER,
  displayName: 'Owner',
  description:
    'Owners have full control over the project, including managing team roles and permissions.',
  assigneeRbacPermission: teamRolesManagePermission,
  limitedAssigneeRbacPermission: teamRolesManageLimitedPermission,
  practiceShaperRelation: PracticeShaperRelationEnum.IS_OWNED_BY,
};

export const dataAccessManagerTeamRole: TeamRole = {
  name: TeamRoleEnum.DATA_ACCESS_MANAGER,
  displayName: 'Data Access Manager',
  description:
    'Data Access Managers are responsible for approving or rejecting data access requests made by consumers.',
  assigneeRbacPermission: teamRolesDataAccessManagePermission,
  limitedAssigneeRbacPermission: teamRolesDataAccessManageLimitedPermission,
  practiceShaperRelation: PracticeShaperRelationEnum.DATA_ACCESS_GRANTED_BY,
};

export const developerTeamRole: TeamRole = {
  name: TeamRoleEnum.DEVELOPER,
  displayName: 'Developer',
  description:
    'Developers are responsible for building and maintaining the system components within the project.',
  assigneeRbacPermission: teamRolesMaintainPermission,
  limitedAssigneeRbacPermission: teamRolesMaintainLimitedPermission,
  practiceShaperRelation: PracticeShaperRelationEnum.IS_DEVELOPED_BY,
};

export const lifecycleManagerTeamRole: TeamRole = {
  name: TeamRoleEnum.LIFECYCLE_MANAGER,
  displayName: 'Lifecycle Manager',
  description:
    'Lifecycle Managers are responsible for managing the lifecycle of a project, including approving or rejecting publish requests.',

  assigneeRbacPermission: teamRolesManageLifecyclePermission,
  limitedAssigneeRbacPermission: teamRolesManageLifecycleLimitedPermission,
  practiceShaperRelation: PracticeShaperRelationEnum.LIFECYCLE_MANAGED_BY,
};

export const witboostTeamRoles: TeamRole[] = [
  ownerTeamRole,
  dataAccessManagerTeamRole,
  developerTeamRole,
  lifecycleManagerTeamRole,
];

export const witboostTeamRolesByName = {
  [TeamRoleEnum.OWNER]: ownerTeamRole,
  [TeamRoleEnum.DATA_ACCESS_MANAGER]: dataAccessManagerTeamRole,
  [TeamRoleEnum.DEVELOPER]: developerTeamRole,
  [TeamRoleEnum.LIFECYCLE_MANAGER]: lifecycleManagerTeamRole,
} satisfies Record<TeamRoleEnum, TeamRole>;

export const witboostTeamRolesByRelation: {
  [key: string]: TeamRole;
} = witboostTeamRoles.reduce((acc, role) => {
  acc[role.practiceShaperRelation.toString()] = role;
  return acc;
}, {} as { [key: string]: TeamRole });
